const CampaignActionTypes = Object.freeze({
  FETCH_CAMPAIGNS_START: 'campaign/FETCH_CAMPAIGNS_START',
  FETCH_CAMPAIGNS_SUCCESS: 'campaign/FETCH_CAMPAIGNS_SUCCESS',
  FETCH_CAMPAIGNS_FAILURE: 'campaign/FETCH_CAMPAIGNS_FAILURE',
  SAVE_CAMPAIGN_START: 'campaign/SAVE_CAMPAIGN_START',
  SAVE_CAMPAIGN_SUCCESS: 'campaign/SAVE_CAMPAIGN_SUCCESS',
  SAVE_CAMPAIGN_FAILURE: 'campaign/SAVE_CAMPAIGN_FAILURE',
  SAVE_NEW_CAMPAIGN_START: 'campaign/SAVE_NEW_CAMPAIGN_START',
  SAVE_NEW_CAMPAIGN_SUCCESS: 'campaign/SAVE_NEW_CAMPAIGN_SUCCESS',
  SAVE_NEW_CAMPAIGN_FAILURE: 'campaign/SAVE_NEW_CAMPAIGN_FAILURE',
  FETCH_CAMPAIGN_DETAILS_START: 'campaign/FETCH_CAMPAIGN_DETAILS_START',
  FETCH_CAMPAIGN_DETAILS_SUCCESS: 'campaign/FETCH_CAMPAIGN_DETAILS_SUCCESS',
  FETCH_CAMPAIGN_DETAILS_FAILURE: 'campaign/FETCH_CAMPAIGN_DETAILS_FAILURE',
  FETCH_CAMPAIGN_GIFTS_START: 'campaign/FETCH_CAMPAIGN_GIFTS_START',
  FETCH_CAMPAIGN_GIFTS_SUCCESS: 'campaign/FETCH_CAMPAIGN_GIFTS_SUCCESS',
  FETCH_CAMPAIGN_GIFTS_FAILURE: 'campaign/FETCH_CAMPAIGN_GIFTS_FAILURE',
  SAVE_CAMPAIGN_GIFT_START: 'campaign/SAVE_CAMPAIGN_GIFT_START',
  SAVE_CAMPAIGN_GIFT_SUCCESS: 'campaign/SAVE_CAMPAIGN_GIFT_SUCCESS',
  SAVE_CAMPAIGN_GIFT_FAILURE: 'campaign/SAVE_CAMPAIGN_GIFT_FAILURE',
  SET_CAMPAIGN_STATE: 'campaign/SET_CAMPAIGN_STATE',
  ADD_CAMPAIGN_GIFT: 'campaign/ADD_CAMPAIGN_GIFT',
  EDIT_CAMPAIGN_GIFT: 'campaign/EDIT_CAMPAIGN_GIFT',
  CHANGE_CAMPAIGN_PUBLISHING_STATUS: 'campaign/CHANGE_CAMPAIGN_PUBLISHING_STATUS',
  GENERATE_CAMPAIGN_QR_CODES: 'campaign/GENERATE_CAMPAIGN_QR_CODES',
  GENERATE_LOOSERS_REPORT_FOR_CAMPAIGN: 'campaign/GENERATE_LOOSERS_REPORT_FOR_CAMPAIGN',
  DELETE_CAMPAIGN_GIFT: 'campaign/DELETE_CAMPAIGN_GIFT',
  FETCH_CAMPAIGN_GIFT_OPERATORS: 'campaign/FETCH_CAMPAIGN_GIFT_OPERATORS',
});

export default CampaignActionTypes;
